<div class="accordion">
  <ng-content select="cft-accordion-element"></ng-content>
</div>
